<template>
  <div class="tips-detail">
    <div
      class="tips-detail-header"
      v-if="dataSource.name || dataSource.title"
      :class="[dataSource.level ? dataSource.level.toLowerCase() : '']"
    >
      {{ dataSource.name || dataSource.title }}
    </div>
    <div
      ref="tipRef"
      class="tips-detail-content"
      :class="{ 'tips-detail-more': showMore, 'tips-detail-less': showLess }"
    >
      <span v-if="!!dataSource.toast" class="tips-detail-message">{{ messages }}</span>
    </div>
    <div class="tips-detail-func" v-if="isShowMore" @click="showMoreDetail()">
      {{ showLess ? $t('expense-2.key160', { cm: '显示全部' }) : $t('common.key45', { cm: '收起' }) }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'tips-more',
  props: {
    dataSource: {
      type: Object,
      default: {},
    },
    invoiceExcessReason: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      showMore: false,
      showLess: false,
      isShowMore: false,
    };
  },
  computed: {
    messages() {
      if (!this.dataSource.toast) return '';
      if (this.dataSource.type === 'MILEAGE_MODIFIED') {
        return this.dataSource.toast.replace(/\|/g, '\n\n');
      }
      return this.dataSource.toast.replace(/\u001E/g, '\n');
    },
  },
  mounted() {
    this.$nextTick(() => {
      const { scrollHeight } = this.$refs.tipRef;
      this.showLess = scrollHeight > 200;
      this.isShowMore = scrollHeight > 200;
    });
  },
  methods: {
    showMoreDetail() {
      this.showMore = !this.showMore;
      this.showLess = !this.showLess;
    },
  },
};
</script>

<style lang="scss">
@import '~assets/css/variable.scss';

.tips {
  &-detail {
    margin-top: px(30);
    .error {
      color: #f04134;
      background: #fff3f0;
    }

    .warn {
      color: #ff800b;
      background: #fffaf0;
    }
  }

  &-detail:nth-child(1) {
    margin-top: 0;
  }

  &-detail-header {
    background: #f9f9f9;
    font-size: px(28);
    color: #0a0f1e;
    height: px(52);
    display: flex;
    align-items: center;
    padding-left: px(20);
    font-weight: 500;
    font-family: 'PingFang SC';
  }

  &-detail-content {
    margin: px(20);
    font-size: px(28);
    color: #71757e;
    line-height: px(40);
    word-break: break-word;
  }

  &-detail-less {
    -webkit-line-clamp: 10;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    overflow: hidden;
  }

  &-detail-more {
    height: auto;
    -webkit-line-clamp: unset;
    overflow: unset;
  }

  &-detail-func {
    font-size: px(24);
    color: $mainColor;
    line-height: px(16);
    margin-top: px(16);
    margin-left: px(20);
  }

  &-detail-message {
    white-space: pre-line;
  }
}
</style>
